import { render } from "./InterestDetails.vue?vue&type=template&id=21e05792&scoped=true"
import script from "./InterestDetails.vue?vue&type=script&lang=js"
export * from "./InterestDetails.vue?vue&type=script&lang=js"

import "./InterestDetails.vue?vue&type=style&index=0&id=21e05792&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21e05792"]])

export default __exports__